export const noSeasonName = 'n/a';
